import { connect } from 'react-redux';

import AuthoriserViewer from '../../../sharedComponents/AuthoriserViewer/AuthoriserViewer';
import { getFPSingleAuthorisersList, getFPMultiAuthorisersList } from '../../../states/payments/selectors';

const mapState = (state, props) => ({
	singleAuthorisersList: getFPSingleAuthorisersList(state, props.paymentId),
	multiAuthorisersList: getFPMultiAuthorisersList(state, props.paymentId),
});

export default connect(mapState)(AuthoriserViewer);
